import logo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import user from '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { RegistrationStatus } from '@bit/ui-common.ui-components/ss-components';
import FsdoHeader from 'components/registration/fsdo/FsdoHeader';
import FsdoSubmit from 'components/registration/fsdo/FsdoSubmit';
import FsdoContactInformation from 'components/registration/fsdo/FsdoContactInformation';
import FsdoOfficeInformation from 'components/registration/fsdo/FsdoOfficeInformation';
import FsdoSubmitConfirmation from 'components/registration/fsdo/FsdoSubmitConfirmation';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ setEnvPrefix } = ssCommonUtils,
layoutConfig = {
    size: { header: 'xs', footer: 'xs' },
    images: { logo, user },
    controlType: 'home',
    bgc: '#f6f6f6'
};

export default class FsdoRegistrationLayout extends React.Component {
    constructor(props) { super(props); }

    showModal(prev) {
        let { services, fsdo } = this.props,
        prevStatus = prev.fsdo.fsdoInfo.fsdoSubmission.request.status,
        currStatus = this.props.fsdo.fsdoInfo.fsdoSubmission.request.status,
        { code } = fsdo.fsdoInfo.fsdoSubmission.request;

        if(
            (prevStatus == null && currStatus != null) ||
            (prevStatus === 'pending' && currStatus !== 'pending')
        ) services.fsdoUpdateModalProps({ visible: true });
    }

    componentDidUpdate(prev) {
        this.showModal(prev);
    }

    render() {
        const
        { services, fsdo } = this.props,
        { showSubmitView, fsdoSubmission } = fsdo.fsdoInfo,
        regStatus = fsdoSubmission.request.status,
        regCode = fsdoSubmission.request.code,
        { visible } = fsdoSubmission.modal.props;

        return (
            <div style={{ minHeight: '6', minWidth: '1000px' }}>
                <AfspLayout {...layoutConfig}>
                    <RegistrationStatus 
                        type='fsdo' 
                        status={regStatus !== 'pending' && regStatus !== 'success' ? regCode : regStatus}
                        visible={visible}
                        failureCallback={code => { 
                            services.fsdoResetSubmissionRequest();
                            switch(code) {
                                case 409:
                                    services.fsdoMarkFieldErrorCode(code, 'email');
                                    services.changeFsdoValidationStep(0);
                                    services.fsdoToggleSubmitView();
                                    services.fsdoToggleErrorMsg();
                                    services.fsdoUpdateModalProps({ visible: false });
                                    break;

                                default: window.location.href = setEnvPrefix('/home');
                            }
                        }}
                    />
                    <FsdoHeader {...this.props} />
                    {showSubmitView ? <FsdoSubmitConfirmation {...this.props} /> : (
                        <div>
                            {[
                                <FsdoContactInformation key='fsdo-contact-info' />,
                                <FsdoOfficeInformation key='fsdo-office-info' />,
                                <FsdoSubmit key='fsdo-submit' />
                            ].map(c => React.cloneElement(c, {...this.props}))}
                        </div>
                    )}
                </AfspLayout>
            </div>
        );
    }
}
